// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"328":"admin","443":"about"}[chunkId] + "." + {"328":"2780f8ae","443":"a4a7577f"}[chunkId] + ".js";
};